import YetAnotherReactLightbox from 'yet-another-react-lightbox';
import './Lightbox.styles.scss';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import Download from 'yet-another-react-lightbox/plugins/download';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Video from 'yet-another-react-lightbox/plugins/video';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import { useCallback, useEffect } from 'react';
import { parseSlides } from '../../../../../../../Chat.functions.ts';
import { LightboxProps } from './Lightbox.types.tsx';

export function Lightbox({
  attachments,
  openAt,
  isLightboxOpen,
  onClose,
}: LightboxProps) {
  const handleBackdropClick = useCallback(
    (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest('.yarl__slide_wrapper') && !target.closest('video, img, .yarl__slide_video, .yarl__slide_image')) {
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    if (isLightboxOpen) {
      document.addEventListener('click', handleBackdropClick);
      return () => document.removeEventListener('click', handleBackdropClick);
    }
  }, [isLightboxOpen, handleBackdropClick]);
  return (
    <YetAnotherReactLightbox
      open={isLightboxOpen}
      close={onClose}
      plugins={[Zoom, Captions, Thumbnails, Download, Fullscreen, Video]}
      render={{
        buttonPrev: attachments.length <= 1 ? () => null : undefined,
        buttonNext: attachments.length <= 1 ? () => null : undefined,
      }}
      styles={{
        container: { backgroundColor: '#FFFFFF' },
        root: {
          '--yarl__color_button': '#54656f',
          '--yarl__color_button_active': '#3b4a54',
          '--yarl__button_filter': 'none',
          '--yarl__thumbnails_container_background_color': '#FFFFFF',
          '--yarl__thumbnails_thumbnail_border_color': '#d1d7db',
          '--yarl__thumbnails_thumbnail_active_border_color': '#1DAA61',
          '--yarl__thumbnails_vignette_size': '0',
          '--yarl__slide_icon_loading_color': '#FFFFFF',
        } as Record<string, string>,
      }}
      index={openAt}
      slides={parseSlides(attachments)}
    />
  );
}
